import { useEffect, useState } from 'react';
import { Search } from '../../@types/Search';
import { toSearchIndex } from '../adapter';
import { gqlQuery } from '../client';
import { PublicApiSettings } from '../config';
import { SiteSearchData } from '../types';
import { RELATED_ADS_QUERY } from './queries';

/**
 * "Fler bilar" on the ad page: the site's latest cars of the same make, the
 * current ad excluded. There is no more-like-this in the public API; this is
 * what web-ui-v2 does too.
 */
const useRelatedAds = (
  publicApi: PublicApiSettings | undefined,
  adId: string,
  manufacturer?: string,
  limit = 3
) => {
  const [response, setResponse] = useState<Search>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!publicApi) return;
    let active = true;
    setLoading(true);
    gqlQuery<SiteSearchData>(publicApi.api, RELATED_ADS_QUERY, {
      market: [publicApi.market],
      branchGroupId: publicApi.branchGroupId,
      manufacturer: manufacturer ? [manufacturer] : undefined,
      perPage: limit + 1,
    })
      .then((data) => {
        const ads = data.search?.ads;
        if (!active || !ads) return;
        const index = toSearchIndex(
          { ...ads, hits: ads.hits.filter((h) => h.ad.id !== adId).slice(0, limit) },
          new URLSearchParams()
        );
        setResponse({ ...index, facets: [] } as unknown as Search);
      })
      .catch(() => undefined)
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, [publicApi?.api.url, publicApi?.branchGroupId, adId, manufacturer, limit]);

  return { loading, response };
};

export default useRelatedAds;
